import {
  SubmitConnectionProps,
} from "../../../types/integrations";
import { useCreateConnection } from "../useCreateConnection";
import axios from "axios";
import { useState } from "react";
import { useTracking } from "../tracking/useTracking";
import { trackingConstants } from "../../../constants/tracking";
import { Connection } from "../../../types/connection";

export const useClickCreateConnectionUx = (linkHeaders?: Record<string, unknown>) => {
  const { createIntegration, isLoading: isConnecting } = useCreateConnection();

  const { track } = useTracking();

  const [errorMessage, setErrorMessage] = useState<string>();
  const [sessionExpired, setSessionExpired] = useState<boolean>(false);
  const [response, setResponse] = useState<Connection>();


  const [isLoading, setLoading] = useState<boolean>();
  const trigger = async ({
    authForm,
    connectionDefinitionId,
    requestId,
  }: SubmitConnectionProps) => {
    try {

      setLoading(true);
      
      const integration: Connection = await createIntegration({
        authForm,
        connectionDefinitionId,
        requestId,
        linkHeaders,
      });

      setLoading(false);

      window?.parent?.postMessage(
        {
          messageType: "LINK_SUCCESS",
          message: integration,
        },
        "*"
      );

      setResponse(integration);
      track(trackingConstants.CREATED_LINK_INTEGRATION, {
        id: integration.id,
        platformVersion: integration.platformVersion,
        connectionDefinitionId: integration.connectionDefinitionId,
        name: integration.name,
        key: integration.key,
        environment: integration.environment,
        platform: integration.platform,
        userId: integration.userId,
        createdAt: integration.createdAt,
        updatedAt: integration.updatedAt,
      }, integration.userId);
    } catch (error) {
      setLoading(false);
      if (axios.isAxiosError(error)) {

        const errorStatus = error.response?.status;
        const errorMessage = error.response?.data?.message;

        if (errorStatus === 404 && errorMessage === "Resource not found") {
          setSessionExpired(true);
          return;
        }

        const message =
          error?.response?.data?.message ||
          "Something went wrong. Please try again later.";

        setErrorMessage(message);
        track(trackingConstants.TRACK_ERROR, {
          message,
        });
        window?.parent?.postMessage(
          { messageType: "LINK_ERROR", message },
          "*"
        );
      }
    }
  };

  return {
    trigger,
    isLoading: isConnecting || isLoading,
    errorMessage,
    response,
    sessionExpired,
  };
};
